import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MobileMenu from './MobileMenu';
import SearchPopup from './SearchPopup';
import navImg from "../../../assets/images/resources/logo-3.png";

const HeaderStyleThree = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isMobileMenu, setMobileMenu] = useState(false);
    const [isPopup, setIsPopup] = useState(false);

    const handleMobileMenu = () => {
        setMobileMenu(!isMobileMenu);
        if (!isMobileMenu) {
            document.body.classList.add("mobile-menu-visible");
        } else {
            document.body.classList.remove("mobile-menu-visible");
        }
    }

    const handlePopup = () => {
        setIsPopup(!isPopup);
    }


    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 100) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <React.Fragment>
            <header className={`main-header-three ${isVisible ? "fixed-header" : ""}`}>
            <nav className="main-menu main-menu-three">
                <div className="main-menu-three__wrapper">
                    <div className="container">
                        <div className="main-menu-three__wrapper-inner">
                            <div className="main-menu-three__left">
                                <div className="main-menu-three__logo">
                                    <Link to="/">
                                        <img src={navImg} alt="Logo" />
                                    </Link>
                                </div>
                                <div className="main-menu-three__main-menu-box">
                                    <div className="mobile-nav__toggler" onClick={handleMobileMenu}>
                                        <i className="fa fa-bars"></i>
                                    </div>
                                    <ul className="main-menu__list">
                                        <MenuItems
                                            parentMenu={parentMenu}
                                            secondParentMenu={secondParentMenu}
                                            activeMenu={activeMenu}
                                        />
                                    </ul>
                                </div>
                            </div>
                            <div className="main-menu-three__right">
                                <div className="main-menu-three__call-and-btn-box">
                                    <div className="main-menu-three__call">
                                        <div className="main-menu-three__call-number">
                                            <p>Need help?</p>
                                            <h5>
                                                <Link to="tel:3075550133">(307) 555-0133</Link>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="main-menu-three__btn-box">
                                        <Link to="/contact">
                                            <button className="main-menu-three__btn thm-btn">
                                                Contact US<span className="icon-dubble-arrow-right"></span>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
                
                <div className={`stricky-header stricked-menu main-menu main-menu-three ${isVisible ? "stricky-fixed" : ""}`}>
                    <div className="sticky-header__content" />
                    <nav className="main-menu main-menu-three">
                        <div className="main-menu-three__wrapper">
                            <div className="container">
                                <div className="main-menu-three__wrapper-inner">
                                    <div className="main-menu-three__left">
                                        <div className="main-menu-three__logo">
                                            <Link to="/">
                                                <img src={navImg} alt="Logo" />
                                            </Link>
                                        </div>
                                        <div className="main-menu-three__main-menu-box">
                                            <div className="mobile-nav__toggler" onClick={handleMobileMenu}>
                                                <i className="fa fa-bars"></i>
                                            </div>
                                            <ul className="main-menu__list">
                                                <MenuItems
                                                    parentMenu={parentMenu}
                                                    secondParentMenu={secondParentMenu}
                                                    activeMenu={activeMenu}
                                                />
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="main-menu-three__right">
                                        <div className="main-menu-three__call-and-btn-box">
                                            <div className="main-menu-three__call">
                                                <div className="main-menu-three__call-number">
                                                    <p>Need help?</p>
                                                    <h5>
                                                        <Link to="tel:3075550133">(307) 555-0133</Link>
                                                    </h5>
                                                </div>
                                            </div>
                                            <div className="main-menu-three__btn-box">
                                                <Link to="/contact">
                                                    <button className="main-menu-three__btn thm-btn">
                                                        Contact US<span className="icon-dubble-arrow-right"></span>
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>

                <MobileMenu handleMobileMenu={handleMobileMenu} />
            </header>
            <SearchPopup isPopup={isPopup} handlePopup={handlePopup} />
        </React.Fragment>
    );
}

export default HeaderStyleThree;
